import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import { Button, Row, Col, Alert} from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG, CONFIG_UTIL } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import utilManagement from '../../../../apis/utilManagement';
import KelasSearch from '../../../../entity/KelasSearch';
import DropdownKelas from '../masterDropDown/DropdownKelas';
import PieChart from './Pie Chart';
import AmChart from './AmPie';
import {Pie} from 'react-chartjs-2';
import {List,ListItem,ListItemText,Collapse, Switch} from '@material-ui/core';
import './assets/style.css';

class ReportLive extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            resMessage: '', 
            alertShow: false,          
            isFetching: false,
            kelas: [],
            jadwal: [],
            dataReport: [],
            mapel:[],
            allSiswa: [],
            kelasSelected: null,
            jadwalSelected: null,
            mapelSelected: null,
            totalSiswa: 0,
            totalSekolah: null,
            startedExam: 0,
            completedExam: 0,
        }
    }
    async componentDidMount() {
        document.title = "Live Report";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();        
        if(!__.isEmpty(this.props.account)) {
            // Fetch Kelas
            console.info('AKUN', this.props)
            const res = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, KelasSearch)
            .catch(function(error) {
                console.log('ERROR ACCOUNT_MANAGEMENT_SEARCH_KELAS', error);
            });
            
            if(res){
                if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        kelas: res.data.data,
                        isFetching: false
                    })
                } else {
                    this.setState({
                        isFetching: false
                    })
                }
            } 
        } 
        
        setInterval(async() => { 
            if(this.state.jadwalSelected !== null) {
                this.renderChart();
                this.getReport();
            }
        }, 2000);        
    }

    async getJadwal(id) {
        this.setState({isFetching: true, alertShow:false, resMessage: '', jadwal: []})
        const res = await accountManagement.get(CONFIG.REPORT_DINAS_LIVE, {
                params: {idKelas: id, idAdmin: this.props.account.idDinas}
            }).catch(function(error) {console.log('ERROR', error);});
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    jadwal: res.data.data,
                    isFetching: false
                })
            } else {
                this.setState({
                    isFetching: false
                })
            }
        }      
    }

    async getReport() {
        if(this.state.jadwalSelected != null) {
            const res = await utilManagement.get(CONFIG_UTIL.UTIL_GET_LIVE_REPORT + this.state.jadwalSelected)
            .catch(function(error) {console.log('ERROR', error);});
            
            if(res){  
                const siswas = res.data.ALL_SISWA.sort((a, b) => {
                    if (a.rata2 > b.rata2) return -1;
                    if (a.rata2 < b.rata2) return 1;
                    return 0;
                });             
               this.setState({ 
                   mapel: res.data.EXAM_DETAIL,
                   totalSiswa: res.data.TOTAL_STUDENT === null ? 0 : res.data.TOTAL_STUDENT,
                   totalSekolah: res.data.TOTAL_SEKOLAH === null ? 0 : res.data.TOTAL_SEKOLAH,
                   completedExam: res.data.CLEARED_EXAM === null ? 0 : res.data.CLEARED_EXAM,
                   startedExam: res.data.CLEARED_EXAM === null ? res.data.TOTAL_STUDENT : (res.data.TOTAL_STUDENT - res.data.CLEARED_EXAM),
                   dataReport: res.data,
                   allSiswa: siswas                   
                })
            }     
        }
    }

    onChangeKelas = (evt) => {
        this.setState({ kelasSelected: evt.target.value, jadwalSelected: null})
        this.getJadwal(evt.target.value);
    }   

    renderChart() {
        // return(
        //     <PieChart 
        //         data={[{'y': this.state.startedExam,'label': 'berlangsung', color: "#f7c940"},
        //             {'y': this.state.completedExam,'label': 'selesai', color: "#5b9420"}]}/>
        // ) 
        let data = [];
        let label = [];
        label.push('Berlangsung ');
        label.push('Selesai ');
        data.push(this.state.startedExam);
        data.push(this.state.completedExam);
        
        // console.info('berlangsung ', this.state.startedExam);
        // console.info('selesai ', this.state.completedExam);
        return(
            <>
                <Pie
                    data={{
                        labels: label,
                        datasets: [{
                            data: data,
                            backgroundColor:['#00CDFF','#FF5D00']
                        }]
                    }}
                    height="200%"
                />
                {/* <AmChart data={[
                    {"y": "berlangsung", "value": this.state.startedExam},
                    {"y": "selesai", "value": this.state.completedExam}
                ]}/> */}
            </>             
        )

    }

    onClick = async(id) => {
        //this.setState({isFetching: true, alertShow:false, resMessage: '', dataReport: []})
        //console.log('idJadwal', this.state.jadwalSelected)
        this.getReport();

    }
    

    componentDidUpdate() {
        //console.log(this.state)
        //this.renderChart()
    }

    render() { 
        const {isFetching, jadwal, mapel, allSiswa} = this.state;
        
        return ( 
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                <Navbar title={'Live Report'}/>  
                    {this.loadAlert()}
                    <div className="container-fluid">  
                        <Row>
                            <Col>
                                <select className="form-control" value={this.state.kelasSelected === null ? "" : this.state.kelasSelected} 
                                    onChange={this.onChangeKelas.bind(this)} required>
                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                    <DropdownKelas kelas={this.state.kelas} />
                                </select>
                            </Col>

                            <Col>
                            <select className="form-control" value={this.state.jadwalSelected === null ? "" : this.state.jadwalSelected}
                                onChange={(e) => this.setState({ jadwalSelected: e.target.value })} required>
                                <option value="" selected disabled>~~ Pilih Profil Cbt ~~</option>
                                {jadwal.map((item, i) =>
                                    <option key={i} value={item.ID_JADWAL_PROFIL_CBT}>{item.NAMA_JADWAL_CBT} ({item.KODE_TIPE_CBT})</option>
                                )}
                            </select>
                            </Col>
                            {/* <Col sm={2}>
                                <Button variant="primary" onClick={this.onClick}><i className="fa fa-search"></i> Lihat</Button>
                            </Col> */}
                        </Row>              

                        {allSiswa.length != 0 && 
                        <div style={{marginTop:'1em'}}>
                            <Row>
                                <Col sm={8}>
                                <ListItem>       
                                    <span style={{color:'DodgerBlue'}}><i className="fa fa-star-o" aria-hidden="true"></i></span>                             
                                    <ListItemText inset primary={'Nilai Rata-Rata Mata Pelajaran'} />
                                </ListItem>
                                <div id="v-scroll">
                                <table className="table table-striped" >
                                    <thead className="thead-dark">
                                    <tr>
                                        <th>No.</th>
                                        <th>Nama</th>
                                        <th>Sekolah</th>
                                        <th>Rataan</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody id="tbody">
                                        {allSiswa.slice(0, 50).map((siswa, i) =>  
                                            <tr key={i}>
                                                <td>{i+1}</td>
                                                <td>{siswa.namaSiswa}</td>
                                                <td>{siswa.namaSekolah}</td>
                                                <td>{siswa.rata2}</td>
                                                <td>{siswa.status == 1 ? <i className="text-success fa fa-check" aria-hidden="true"></i> : 
                                                    <i className="text-danger fa fa-remove" aria-hidden="true"></i>}                                            
                                                </td>
                                            </tr>                                    
                                        )} 
                                    </tbody>
                                </table>
                                </div>
                                </Col>

                                <Col sm={4}>
                                    <div style={{marginTop: '30px'}}>
                                    <h6>total sekolah : {this.state.totalSekolah} </h6>
                                    <h6>total peserta : {this.state.totalSiswa} </h6>
                                    {this.renderChart()}
                                    </div>
                                </Col>
                            </Row>                            
                        </div>
                        } 

                        {mapel.length != 0 && 
                        <div style={{marginTop:'3em'}}>
                            <ListItem>       
                                <span style={{color:'DodgerBlue'}}><i className="fa fa-star-o" aria-hidden="true"></i></span>                             
                                <ListItemText inset primary={'Nilai Per Mata Pelajaran'} />
                            </ListItem>
                            <Row>
                            {mapel.map((mapel,i) =>                             
                                <Col sm={6} key={i}>
                                    <h6>{mapel.NAMA_SUB_PROFIL}</h6>
                                    <table className="table table-bordered" >
                                        <thead className="thead-dark">
                                        <tr>
                                            <th>No.</th>
                                            <th>Nama</th>
                                            <th>Sekolah</th>
                                            <th>Score</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody id="tbody">
                                            {mapel.TOP_TEN.map((v, j) =>  
                                                <tr key={j}>
                                                    <td>{j+1}</td>
                                                    <td>{v.namaSiswa}</td>
                                                    <td>{v.namaSekolah}</td>
                                                    <td>{v.skor}</td>
                                                    <td>{v.isComplete == 1 ? <i className="text-success fa fa-check" aria-hidden="true"></i> : 
                                                        <i className="text-danger fa fa-remove" aria-hidden="true"></i>}                                            
                                                    </td>
                                                </tr>                                    
                                            )} 
                                        </tbody>
                                    </table>
                                    
                                </Col>
                            
                            )}   
                            </Row>                         
                        </div>  
                        }                     
                    </div>    
                </div>
            </div>    
        );
    }

    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(ReportLive);